import { render } from "./LessonsHeader.vue?vue&type=template&id=c91d33d6&scoped=true"
import script from "./LessonsHeader.vue?vue&type=script&lang=js"
export * from "./LessonsHeader.vue?vue&type=script&lang=js"

import "./LessonsHeader.vue?vue&type=style&index=0&id=c91d33d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c91d33d6"]])

export default __exports__